import moment from "moment";

export function dateSelectionReducer(state: any, action: any) {
    switch (action.type) {
        case "SET_YEARLY": {
            const { isYearly, period } = action.payload;
            const view = isYearly ? "yearly" : "monthly";
            const startDate = (isYearly
                ? period?.startOf("year").format("YYYY-MM-DD")
                : `${period?.format("YYYY-MM")}-01`) ?? '';
            const endDate = (isYearly
                ? period?.endOf("year").format("YYYY-MM-DD")
                : `${period?.format("YYYY-MM")}-${period?.daysInMonth()}`) ?? '';
            return { ...state, isYearly, view, startDate, endDate };
        }

        case "SET_FROM_DATE":
            return {
                ...state,
                fromDate: action.payload.value,
                view: "daterange",
                startDate: action.payload.value,
            };

        case "SET_TO_DATE":
            return {
                ...state,
                toDate: action.payload.value,
                view: "daterange",
                endDate: action.payload.value,
            };

        case "SET_START_AND_END_DATES":
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
            };

        case "CLEAR_DATES": {
            const currentDate = new Date();
            const firstDay = moment(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
            const lastDay = moment(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0));
            return {
                ...state,
                fromDate: null,
                toDate: null,
                startDate: firstDay.format("YYYY-MM-DD"),
                endDate: lastDay.format("YYYY-MM-DD"),
                view: "monthly",
            };
        }

        default:
            return state;
    }
}
